import React from 'react'
import ReservationBuilderActions from './actions/ReservationBuilderActions'
import NumberSpinner from "../NumberSpinner/NumberSpinner"
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import DateHelper from '../DateHelper/DateHelper';
import { parseISO, zonedTimeToUtc, utcToZonedTime, format } from 'date-fns';
import { subMonths, subYears } from "date-fns";



export default class ReservationBuilderAdditionalInformation extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onChangeFormFields = this.onChangeFormFields.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.renderFieldErrors = this.renderFieldErrors.bind(this);
    this.renderFieldClasses = this.renderFieldClasses.bind(this);
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    
  };

    /*** Lifecycle Methods ***/

    componentDidMount() {
      this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
          {"types": ["address"]});
      this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
    }

  /*** Render methods ***/ 

  render() {  
    return (
      <fieldset>
        <div className="customer-information">
          <div className="panel panel-default">
            <div className="panel-heading"><h3 className="panel-title">{I18n.t('guest_information')}</h3></div>
            <div className="panel-body container" style={{padding: "15px"}}>
              <div className="row">
                <div className="col-md-12 customer-form-wrapper">
               
                    {this.renderForms()}
                 
                </div>
              </div>
            </div>
          </div>
        </div> 
      </fieldset>
    );
  };

  renderForms() {
    if(this.props.form_titles || this.props.forms) {
      var title = ""
      var forms = this.props.forms.map((form, idx) => {
        form.map((field) => {
           title = field.form_title
           return title
        })
     
        return (
          <fieldset className="field-group" key={idx}>
              <legend>{title}</legend>
              {this.renderFormFields(form)} 
          </fieldset>
        )
      })
      return (
        <div>
          {forms}
        </div>
      )
    }
  }

  renderFormFields(form) {
    if(form) {
      var formFields = form.sort((a,b) => a.position - b.position).map((form_field, idx) => {
        var field_answer = null
        var number_field_answer = null
        var date_field_answer = null
        var address_field_answer = null
        if(this.props.reservation.customer) {
          var formFieldAnswers = this.props.reservation.customer.answers || []
          formFieldAnswers.map((answer) => {
            if(answer.form_field_id == form_field.id){
              if(answer.number_answer) {
                number_field_answer = answer.number_answer
              } else if(answer.date_answer) {
                if(typeof answer.date_answer == 'string') {
                  date_field_answer = parseISO(answer.date_answer)
                } else {
                  date_field_answer = answer.date_answer
                }
              } else if(answer.formatted_address) {
                address_field_answer = answer.formatted_address 
              } else {
                field_answer = answer.answer
              }
            } 
          })
        } 
        
        var formFieldOptions = form_field.options.map((option, index) => {
          return <option key={index} value={option.option}>{option.option}</option>
        })
  
        if(form_field.field_type == "text_field_single_line") {
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <input className={this.renderFieldClasses(form_field.field)} name={form_field.id} id={form_field.id} value={field_answer ? field_answer : ""} onChange={this.onChangeFormFields}  />
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }
  
        if(form_field.field_type == "select_box") {
          return (
            <div className='row' key={idx}>        
              <div className="col-lg-6">
                <div className="form-group ">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <select className={this.renderFieldClasses(form_field.field)} name={form_field.id} id={form_field.id} value={field_answer ? field_answer : "please_select_one"} onChange={this.onChangeFormFields} >
                    <option value="please_select_one">{I18n.t("select_ellipsis")}</option>
                    {formFieldOptions}
                  </select>
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }
        
        if(form_field.field_type == "number_input") {
          return (
            <div className='row'  key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                    <NumberSpinner
                      // style= {{textAlign: 'right'}}
                      hasError={this.renderFieldClasses(form_field.field, true)}
                      name='number'
                      id={form_field.id}
                      onChange={this.onChangeFormFields} 
                      value={number_field_answer ?  number_field_answer : ""} 
                    />
                    {this.renderFieldErrors(form_field.field, true)}
                </div>
              </div>
            </div>
          )
        }
        
        if(form_field.field_type == "date_form_field") {
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <DatePickerInput
                    selectedDate={date_field_answer}
                    dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                    customChangeHandler={this.onChangeDate}
                    customChangeSource="FormField"
                    formFieldID={form_field.id}
                    classNames={this.renderFieldClasses(form_field.field)}
                    minDate={subYears(new Date(), 100)}
                  />
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }
  
        if(form_field.field_type == "text_area_multi_line") {
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <textarea className={this.renderFieldClasses(form_field.field)} name={form_field.id} id={form_field.id} value={field_answer ? field_answer : ""} onChange={this.onChangeFormFields}  />
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }
  
        if(form_field.field_type == "phone_number") {
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{I18n.t('mobile_number')}*</label>
                  <input type="tel" className={this.renderFieldClasses(form_field.field)} name={form_field.id} id={form_field.id} value={field_answer ? field_answer : ""} onChange={this.onChangeFormFields}  />
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }

        if(form_field.field_type == "numbered_scale") {
          var current_rating_answer = []
          if(this.props.rating_answers.length > 0) {
  
            this.props.rating_answers.map((rating_answer) => {
              if(rating_answer.form_field_id == form_field.id) {
                current_rating_answer = rating_answer
              }
            })   
          } else {
            current_rating_answer = {
              answer: field_answer,
              selected: true
            }
          }
            
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  {this.renderRatingRangeForm(form_field, current_rating_answer)}
                  <br></br>
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }

        if(form_field.field_type == "emoji_rating") {
          var current_emoji_answer = []
          if(this.props.emoji_answers.length > 0) {
            this.props.emoji_answers.map((emoji_answer) => {
              if(emoji_answer.form_field_id == form_field.id) {
                current_emoji_answer = emoji_answer 
              }
            })  
          } else {
            current_emoji_answer = {
              answer: field_answer,
              selected: true
            }
          }
          return (
            <div className='row' key={idx}>
              <div className="col-lg-6">
                <div className="form-group" style={{paddingBottom: "30px"}}>
                  <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  {this.renderEmojiRatingForm(form_field, current_emoji_answer)}
                  <br></br>
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }

        if(form_field.field_type == "address") {
          return (
            <div className="row" key={idx}>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <input  
                    type="text" 
                    id={form_field.id}
                    ref={this.autocompleteInput} 
                    name="answers[formatted_address]" 
                    value={address_field_answer ?  address_field_answer : ""}
                    autoComplete="new-password" 
                    className={this.renderFieldClasses(form_field.field)}
                    onChange={(e) => this.onChangeAddress(form_field.id, e)}/>
                  {this.renderFieldErrors(form_field.field)}
                </div>
              </div>
            </div>
          )
        }
      });
    }

    return (
      <div>
        {formFields}  
      </div>
    );
  }


 renderEmojiRatingForm(form_field, current_emoji_answer) {
    var rating_range = 5
    var rating_range_arr = []
    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }
    var rating_range_lines = rating_range_arr.map((rating) => {
    
      if(rating_range == 5) {
        if(rating == 1) {

          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {

          var list_emoji = <i className="far fa-frown fa-2x"></i>
           
        } else if (rating == 3) {

          var list_emoji = <i className="far fa-meh fa-2x"></i>

        } else if (rating == 4) {

          var list_emoji = <i className="far fa-smile fa-2x"></i>
          
        } else {

          var list_emoji = <i className="far fa-grin fa-2x"></i>

        } 
        

      }
      
      return (
        <li className={rating == current_emoji_answer.answer && current_emoji_answer.selected == true  ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.onChangeSelectedEmoji(rating, form_field)} key={rating}>{list_emoji}</li>
      )
    })
  
  if(this.props.rating_range != 'none') {

    return (
      <ul className="emoji-scale-ul">
        {rating_range_lines}
      </ul>
    )
  } 

}


renderRatingRangeForm(form_field, current_rating_answer) {
  if(form_field) {
    var rating_range = parseInt(form_field.rating_scale.rating_range, 10)
    var rating_range_arr = []
    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }
    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 10) {

        if(rating <= 3){
          var color = "#aa381d"
        } else if (rating > 3 && rating <= 6) {
          var color = "#d18140"
        } else if (rating > 3 && rating <= 6) {
          var color = "#bba350"
        } else {
          var color = "#61a544"
        }
      }

      if(rating_range == 5) {
        if(rating < 3){
          var color = "#aa381d"
        } else if (rating  == 3) {
          var color = "#bba350"
        } else if (rating > 3 && rating <= 6) {
          var color = "#61a544"
        } else {
          var color = "#61a544"
        }

      }
      
      return (
        <li className={rating == current_rating_answer.answer && current_rating_answer.selected == true ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.onChangeSelectedRating(rating, form_field)} key={rating} style={{borderColor: color, color:color}}>{rating}</li>
      )
    })
  }
    if(this.props.rating_range != 'none') {

      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 

  }


   // *** Change Handlers ***/

  onChange(event) {
    var customer = this.props.reservation.customer ? this.props.reservation.customer : {};
    customer[event.target.name] = event.target.value;
    this.forceUpdate();
    ReservationBuilderActions.setCustomer(customer);
  }

  handlePlaceChanged() {
    var addressObject = this.autocomplete.getPlace()
    var address = addressObject.address_components
    if(this.props.reservation.customer){
      var customer1 = this.props.reservation.customer
    } else {
      var customer1 = {}
    }
    var form_field_address_field_id = this.props.form_field_address_field_id
    for(let i = 0; i < address.length; i++){
      for(let j = 0; j < address[i].types.length; j++){
        if(address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if(address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if(address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if(address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if(address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if(address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }
    var newAddressObject = {
      address_1: street_number ? `${street_number} ${route}` : route,
      formatted_address: addressObject.formatted_address,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code,
      form_field_id: form_field_address_field_id
    }
    if(this.props.forms) {
      this.props.forms.map((form)=> {
        form.map((field) => {
          if(field.id === newAddressObject.form_field_id) {
            var found = false;
            if(customer1.answers) {
              for(var i = 0, ilen = customer1.answers.length; i < ilen; i++) {
                if (customer1.answers[i].form_field_id === newAddressObject.form_field_id) {
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              customer1.answers.map((answer, idx) => {
                if (answer.form_field_id === newAddressObject.form_field_id) {
                  customer1.answers[idx] = newAddressObject    
                }
              })
            } else {
              if(!customer1.answers) {
                customer1.answers = []
              }
              var new_answer = newAddressObject
              customer1.answers.push(new_answer)
            }
          }
        })
      })
    }
    this.forceUpdate();
    return ReservationBuilderActions.setCustomer(customer1);
  }

  onChangeAddress(form_field_id, e) {
    if(this.props.reservation.customer){
      var customer1 = this.props.reservation.customer
    } else {
      var customer1 = {}
    }
   
    if(this.props.forms) {
      this.props.forms.map((form) => {
        form.map((field) => {
          if(field.id === form_field_id) {
            var found = false;
            if(customer1.answers) {
              for(var i = 0, ilen = customer1.answers.length; i < ilen; i++) {
                if (customer1.answers[i].form_field_id === form_field_id) {
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              customer1.answers.map(answer => {
                if (answer.form_field_id === form_field_id) {
                  answer.formatted_address = e.target.value        
                }
              })
            } else {
              if(!customer1.answers) {
                customer1.answers = []
              }
              if(e.target.name == 'answers[formatted_address]') {
                var new_answer = {
                  form_field_id: form_field_id,
                  formatted_address: e.target.value
                }
              }
              customer1.answers.push(new_answer)
            }
          }
        })
      })
    }
    this.forceUpdate();
    return ReservationBuilderActions.setCustomer(customer1, form_field_id);
    // this.setState({
    //   guest_information: customer,
    //   form_field_address_field_id: form_field_id,
    // })
  }


  onChangeFormFields(e) {
      if(this.props.reservation.customer){
        var customer1 = this.props.reservation.customer
      } else {
        var customer1 = {}
      }
      if(this.props.forms) {
        this.props.forms.map(form => {
          form.map((field) => {
            if(field.id === e.target.id) {
              var found = false;
              if(customer1.answers) {
                for(var i = 0, ilen = customer1.answers.length; i < ilen; i++) {
                  if (customer1.answers[i].form_field_id === e.target.id) {
                    found = true;
                    break;
                  }
                }
              }
              if (found) {
                customer1.answers.map(answer => {
                  if (answer.form_field_id === e.target.id) {
                    if(e.target.name == 'number') {
                      answer.number_answer = e.target.value
                    } else if(e.target.name == 'date') {
                      answer.date_answer = e.target.value
                    } else {
                      answer.answer = e.target.value
                    }
                  }
                })
              } else {
                if(!customer1.answers) { 
                  customer1.answers = []
                }
                if(e.target.name == 'number') {
                  var new_answer = {
                    form_field_id: e.target.id,
                    number_answer: e.target.value
                  }
                } else if (e.target.name == 'date') {
                  var new_answer = {
                    form_field_id: e.target.id,
                    date_answer: e.target.value
                  }
                } else {
                  var new_answer = {
                    form_field_id: e.target.id,
                    answer: e.target.value
                  }
                }
                customer1.answers.push(new_answer)
              }
            }
          })
        })
      }
    this.forceUpdate();
    return ReservationBuilderActions.setCustomer(customer1);
  }

  onChangeSelectedRating(rating, form_field){
    
    var answers = this.props.rating_answers

    this.props.forms.map(form => {
    form.map((field) => {
      if(field.id === form_field.id) {
        var found = false;
        if(answers) {
          for(var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field.id) {       
              answer.answer = rating + ""
              answer.form_field_id = form_field.id
              answer.form_field_type = form_field.field_type
              answer.selected = !answer.selected      
            } 
          })
        } else {
          if(!answers) {
            answers = []
          }
          var new_answer = {
            answer: rating + "",
            form_field_id: form_field.id,
            form_field_type: form_field.field_type,
            selected: true
          }
          answers.push(new_answer)
        }
      }
    })
  })
  return ReservationBuilderActions.setRatingState(answers);
}

onChangeSelectedEmoji(emoji, form_field) {
  var answers = this.props.emoji_answers
    this.props.forms.map(group => {
      group.map((field) => {
        if(field.id === form_field.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === form_field.id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map((answer) => {
              if (answer.form_field_id === form_field.id) {          
                answer.answer = emoji + ""
                answer.form_field_id = form_field.id
                answer.form_field_type = form_field.field_type
                answer.selected = !answer.selected
                
              } 
            })
          } else {
            if(!answers) {
              answers = []
            }
            var new_answer = {
              answer: emoji + "",
              form_field_id: form_field.id,
              form_field_type: form_field.field_type,
              selected: true
            }
            answers.push(new_answer)
          }
        }
      })
    })
    return ReservationBuilderActions.setEmojiState(answers);
  }

  onChangeDate(date, id) {
    this.onChangeFormFields({
      target: {
        name: 'date',
        value: date,
        id: id
      }
    }); 
  }


  // *** Error Handling *** /

  renderFieldErrors(field, numberInput) {
    if (this.props.errors) {
      var idx = 0
      var errors = this.props.errors.map( (error) => {
        
        if(error === "Phone Number is invalid " && field === 'phone_number') {
          idx = idx + 1 
          error = I18n.t("is_invalid") 
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Phone Number has already been taken " && field === 'phone_number') {
          idx = idx + 1
          error = I18n.t("has_already_been_taken")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Email is an invalid email address " && field === 'email') {
          idx = idx + 1 
          error = I18n.t("not_a_valid_email")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error === "Email has already been taken " && field === 'email') {
          idx = idx + 1
          error = I18n.t("has_already_been_taken")
          return <li key={idx}><b>&#x2022;</b> {error}</li>
        }
        if(error.toLowerCase() == `${field.toLowerCase()} can't be blank ` && numberInput != true){
          
          idx = idx + 1 
          error = I18n.t("cant_be_blank") 
          return <li key={idx}>{error}</li>
        } 
        if(error.toLowerCase() == `${field.toLowerCase()} can't be blank ` && numberInput == true){
          idx = idx + 1 
          error = I18n.t("cant_be_blank") 
          return <li style={{textAlign: "left"}} key={idx}>{error}</li>
        } 
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
  
  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if(this.props.errors){
      this.props.errors.forEach((error) => {
        if(error === "Phone Number is invalid " || error === "Phone Number has already been taken " && field === 'phone_number') {
          classname = classname + ' has-errors'
        } else if((error === "Email is an invalid email address " || error === "Email has already been taken ") && field === 'email') {
          classname = classname + ' has-errors'   
        } else if (error.toLowerCase() == `${field.toLowerCase()} can't be blank ` ) {
          classname = classname + ' has-errors'   
        }
      })   
      return classname
    }
  }

  // *** Helper Methods *** //

  processCustomerName(customer) {
    if (customer.id && customer.first_name && customer.last_name) {
      var markup = customer.last_name + ', ' + customer.first_name + customer.email ? ' (' + customer.email + ')' : ''
      if (customer.city && customer.state) {
        markup = markup + ' - ' + customer.city + ', ' + customer.state;
      }
      return markup;
    } else {
      return customer.text;
    }
  } 

  capitalizeFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
  }

};